
















































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwSelect } from '@libs-uuif/shared/sw-select';
import Component from 'vue-class-component';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwForm, SwFormRow,  SwFormRowError } from '@libs-uuif/shared/sw-form';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { Prop } from 'vue-property-decorator';
import { required } from 'vuelidate/lib/validators';
import RegexValidators from '../../../shared/regex-validators';

const cssPrefix = 'edit-basic-info';
const domainNameValidation: any = (domainName: string) => {
  const regexStr =  new RegExp(RegexValidators.orgDomainName);
  if (regexStr.test(domainName)) {
    return true;
  }
  return false;
};

@Component({
  components: {
    SwSelect,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwTextfield,
    SwForm,
    SwFormRow,
    SwFormRowError,
  },
  validations: {
    domainName: { required, isValidDomainName: domainNameValidation },
  },
})
export default class EditOrgDomainName extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop({ required : true })
  showEditDomainModal: boolean;

  @Prop({ required : true })
  orgDomainName: any;

  domainName: string = '';
  domainValid: boolean = true;
  tempDomainName: string = '';

  created() {
    this.domainName = this.orgDomainName;
    this.tempDomainName  = this.orgDomainName;
  }

  checkInputValidation(): boolean {
    this.$v!.domainName!.$touch();
    if (!this.$v!.domainName!.$invalid &&
        (this.domainName !== null && this.domainName !== '') &&
        this.$v!.domainName!.isValidDomainName) {
      return true;
    }
    return false;
  }

  submit() {
    if (!this.checkInputValidation()) {
      return;
    }
    if (this.tempDomainName === this.domainName) {
      this.closeDialog({ refresh: false });
      return;
    }
    const payload: any = {
      mode: 'EMAILDOMAIN',
      orgDomainName: this.domainName,
    };
    this.$store.dispatch('SnbProfileStoreModule/updateBasicInfo', payload)
    .then((resp) => {
      if (resp.msgCode === 'MSWAPP:SUCCESS') {
        this.closeDialog({ refresh: true });
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
        this.$store.commit('stopLoading');
      }
    })
    .catch((err:any) => {
      console.error(err);
    });
  }

  cancel() {
    this.closeDialog();
  }

  closeDialog(params:any = { refresh: false }) {
    this.$emit('closeDomainChangeDialog', params);
  }

}
